import React, { useContext } from 'react';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import PropTypes from 'prop-types';
import { Drawer, DrawerItem, DrawerNav } from '@thd-olt-component-react/drawer';
import { CheckNearByStore } from '../CheckNearByStore';
import { CHECK_NEARBY_STORES, BOSS_DOMINANT } from '../../../../constants';
import './bossDrawer.scss';

export const BossDrawer = ({ storeName, isQuickViewOpen, setIsQuickViewOpen, itemId }) => {
  const { channel } = useContext(ExperienceContext);
  let maxSize = window.matchMedia('(orientation: portrait)').matches ? 175 : 150;
  // galaxy fold in portrait
  if (window.screen.width < 300 && window.matchMedia('(orientation: portrait)').matches) { maxSize = 215; }

  return (
    <div className="BossDrawer__drawerWrapper" data-testid="boss-drawer">
      <Drawer
        open={isQuickViewOpen}
        onClose={() => setIsQuickViewOpen(false)}
        initialItem="mobile-quick-view"
        position="bottom"
        maxSize={maxSize}
      >
        <DrawerItem name="mobile-quick-view">
          <div className="BossMobileDrawer__wrapper">
            <DrawerNav backLinkTxt="">
              <span className="BossMobileDrawer__header">
                <strong>
                  Need More?
                </strong>
              </span>
            </DrawerNav>
            <div className="BossMobileDrawer__divider" />
            <span className="BossMobileDrawer__body">
              {BOSS_DOMINANT.partOne} <strong>{storeName}</strong> {BOSS_DOMINANT.partTwo}
            </span>
            <span className="BossMobileDrawer__body">
              <strong>{'Need it even sooner? '}</strong>
              <CheckNearByStore itemId={itemId}>
                <span
                  className="u__default-link"
                  onClick={() => setIsQuickViewOpen(false)}
                  role="button"
                  tabIndex={0}
                > { CHECK_NEARBY_STORES }
                </span>
              </CheckNearByStore>
              <span>{' to see if another store has enough items in stock.'}</span>
            </span>
          </div>
        </DrawerItem>
      </Drawer>
    </div>
  );
};

BossDrawer.propTypes = {
  storeName: PropTypes.string,
  itemId: PropTypes.string,
  isQuickViewOpen: PropTypes.bool,
  setIsQuickViewOpen: PropTypes.func,
};

BossDrawer.defaultProps = {
  storeName: '',
  itemId: null,
  isQuickViewOpen: false,
  setIsQuickViewOpen: () => {},
};
